import XesAxios from './XesAxios'
import envConfig from './config'
const { env, mock, baseApi, mockApi } = envConfig

let BASE_URL = ''
if (env === 'production') {
  BASE_URL = baseApi
} else {
  BASE_URL = mock ? mockApi : baseApi
}

export default {
  // 活动信息
  activityInfo() {
    return XesAxios.get(`${BASE_URL}/activity/info`)
  },
  // 用户当前征文信息
  personalArtical(params) {
    return XesAxios.get(`${BASE_URL}/artical/personalartical`, {
      params
    })
  },
  // 征文榜单/美文
  articalRecommend(params) {
    return XesAxios.get(`${BASE_URL}/artical/totalrank`, {
      params
    })
  },
  // 名单
  rosterRecommend(params) {
    return XesAxios.get(`${BASE_URL}/artical/appraisal`, {
      params
    })
  }
}
